import styled, { css } from 'styled-components'
import { remCalculator } from '../theming/utilities'
import { SeoStyledCopy } from './types'

const collapsedHeight = 150
const marginBottom = (props) => props.theme.size.spacing.lg

const StyledContainer = styled.div`
  margin-bottom: ${(props) => remCalculator(marginBottom(props))};
  .a {
    cursor: pointer;
  }

  button {
    border: none;
    background: ${(props) =>
      props.theme.channel === 'sainsburys' ? props.theme.color.monochrome.lighter : props.theme.color.monochrome.white};
    width: 100%;
    color: ${(props) => props.theme.color.palette['brand-1']};
    text-decoration: underline;
  }
`

const StyledCopy = styled.div<SeoStyledCopy>`
  position: relative;
  overflow: hidden;
  text-align: left;

  ${(props) =>
    props.isCollapsed
      ? css`
          height: ${collapsedHeight}px;
        `
      : css`
          height: auto;
        `}

  ${(props) =>
    props.isCollapsed && props.isValidCollapsible
      ? css`
          height: ${collapsedHeight}px;
          &::after {
            pointer-events: none;
            content: '';
            display: block;
            width: 100%;
            position: absolute;
            height: 85px;
            background: ${props.theme.channel === 'sainsburys'
              ? 'linear-gradient(to bottom,rgba(242, 242, 242, 0) 0%, rgba(242, 242, 242, 0.5) 25%, rgba(242, 242, 242, 1) 100%)'
              : 'linear-gradient(to bottom,rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 25%, rgba(255, 255, 255, 1) 100%)'};
            bottom: 0;
            left: 0;
          }
        `
      : css`
          height: auto;
        `}

  ${(props) =>
    !props.isValidCollapsible &&
    css`
      height: auto;
    `}

  ul,
  ol {
    list-style: inside;
    margin: 0 0 30px ${(props) => remCalculator(marginBottom(props))};
    display: block;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    margin-bottom: 10px;
  }
`

const StyledSeoSeeMoreLess = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  strong {
    background: ${(props) =>
      props.theme.channel === 'sainsburys' ? props.theme.color.monochrome.lighter : props.theme.color.monochrome.white};
    padding: 5px 20px;
    z-index: 1;
    text-decoration: none;
  }
  span {
    width: 100%;
    position: absolute;
    height: 1px;
    background: ${(props) => props.theme.color.monochrome.base};
  }
`

export { StyledContainer, StyledCopy, StyledSeoSeeMoreLess }
